import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
@Component({
	selector: 'app-venue-type',
	templateUrl: './venue-type.component.html',
	styleUrls: ['./venue-type.component.css']
})
export class VenueTypeComponent implements OnInit, WidgetCore, OnDestroy {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@ViewChild('childGraphArea', { static: true }) ChildGraphElement: ElementRef;

	@Input() key: string;
	@Input() iscustomendpoint: any;
	@Input() queryorderby: any;
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: any;

	public reloadSubscription;
	public widgetDataSubscription;
	public hasData = true;
	public hasChildVenueData = false;
	public showLoad = false;
	public columns: any[];
	public venueTypeCategories: string[] = [];
	public venueTypeData: { y: number; color: string; parent_id: number }[] = [];
	public childVenueTypeData: { name: string; y: number; color: string }[] = [];
	public childVenueTypeTitle: string;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;
	public isR101: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.queryorderby = this.queryorderby ? JSON.parse(decodeURI(this.queryorderby)) : [];
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.isR101 = this.analyticsDataModel.config.directoryName == 'default-r101';
		this.requestData();
	}

	requestData(): void {
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				if (response.success) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
				this.showLoad = false;
			});
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	processResponseData(response): void {
		this.venueTypeCategories = [];
		this.venueTypeData = [];
		response.forEach((item) => {
			this.venueTypeCategories.push(this.isR101 ? item.category_name.split(' ').join('<br>') : item.category_name);
			this.venueTypeData.push({ y: item.impressions, color: item.color_code, parent_id: item.id });
		});
		this.generateChartObj();
	}

	generateChartObj(): void {
		// tslint:disable-next-line: no-this-assignment
		Highcharts.chart(this.graphElement.nativeElement, {
			chart: {
				type: 'column',
				height: this.isR101 ? 230 : null
			},
			title: {
				text: ''
			},
			xAxis: {
				categories: this.venueTypeCategories,
				labels: {
					rotation: this.isR101 ? 0 : undefined
				}
			},
			yAxis: {
				title: {
					text: 'Impressions'
				},
				allowDecimals: false
			},
			tooltip: {
				backgroundColor: '#333333',
				borderColor: '#333333',
				borderRadius: 5,
				followPointer: false,
				style: {
					color: '#FFFFFF',
					fontWeight: '400',
					fontSize: '12px',
					fontFamily: 'Roboto'
				},
				useHTML: true,
				formatter: function (): string {
					return `${this.key}: ${this.y.toLocaleString()} Impressions`;
				}
			},
			plotOptions: {
				bar: {
					grouping: false
				},
				series: {
					cursor: 'pointer',
					events: {
						click: function (venueType) {
							this.requestChildVenueTypeData(venueType.point.parent_id);
						}.bind(this)
					}
				}
			},
			legend: {
				enabled: false
			},
			series: [
				{
					maxPointWidth: 50,
					type: 'column',
					data: this.venueTypeData
				}
			]
		});
	}

	requestChildVenueTypeData(parentId): void {
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key, null, null, null, null, null, parentId)
			.subscribe((response: any) => {
				if (response.success) {
					this.hasChildVenueData = true;
					this.processChildVenueTypeResponseData(response.data);
				} else {
					this.hasChildVenueData = false;
				}
				this.showLoad = false;
			});
	}
	processChildVenueTypeResponseData(response): void {
		var defaultColor = {
			Transit: '#3B82F6',
			Airports: '#D97706',
			Buses: '#0284C7',
			'Taxi & Rideshare TV': '#7C3AED',
			'Taxi & Rideshare Top': '#DB2777',
			Subway: '#EA580C',
			'Train Stations': '#DC2626',
			Ferry: '#2DD4BF',
			Retail: '#D97706',
			'Fueling Stations': '#059669',
			'Convenience Stores': '#0284C7',
			Grocery: '#7C3AED',
			'Liquor Stores': '#DB2777',
			Mall: '#EA580C',
			'Cannabis Dispensaries': '#DC2626',
			Pharmacies: '#2DD4BF',
			'Parking Garages': '#93C5FD',
			Outdoor: '#EA580C',
			Billboards: '#D97706',
			'Urban Panels': '#0284C7',
			'Bus Shelters': '#7C3AED',
			'Health & Beauty': '#DB2777',
			Gyms: '#D97706',
			Salons: '#0284C7',
			Spas: '#7C3AED',
			'Point of Care': '#DC2626',
			Education: '#4F46E5',
			'Doctors Offices': '#D97706',
			'Veterinary Offices': '#0284C7',
			Schools: '#D97706',
			'Colleges and Universities': '#0284C7',
			'Office Buildings': '#D97706',
			Leisure: '#0284C7',
			'Recreational Locations': '#D97706',
			'Movie Theaters': '#0284C7',
			'Sports Entertainment': '#7C3AED',
			Bars: '#DB2777',
			'Casual Dining': '#EA580C',
			QSR: '#DC2626',
			Hotels: '#2DD4BF',
			'Golf Carts': '#0284C7',
			'Night Clubs': '#0D9488',
			'High-End Dining': '#059669',
			Government: '#7C3AED',
			DMVs: '#D97706',
			'Military Bases': '#0284C7',
			'Post Offices': '#DB2777',
			Financial: '#059669',
			Banks: '#D97706',
			Residential: '#2DD4BF',
			'Apartment Buildings and Condominiums': '#D97706'
		};

		this.childVenueTypeData = [];
		response.forEach((item) => {
			this.childVenueTypeTitle = item.category_name;
			this.childVenueTypeData.push({
				name: item.child_category_name,
				y: item.impressions,
				color: defaultColor[item.child_category_name] ? defaultColor[item.child_category_name] : null
			});
		});
		this.generateChildChartObj();
	}

	generateChildChartObj(): void {
		// tslint:disable-next-line: no-this-assignment
		Highcharts.chart(this.ChildGraphElement.nativeElement, {
			chart: {
				width: this.isR101 ? 850 : 563,
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie'
			},
			title: {
				text: this.childVenueTypeTitle
			},
			tooltip: {
				shadow: false,
				backgroundColor: '#333333',
				borderColor: '#333333',
				borderRadius: 5,
				followPointer: false,
				style: {
					color: '#FFFFFF',
					fontWeight: '400',
					fontSize: '12px',
					fontFamily: 'Roboto'
				},
				useHTML: true,
				formatter: function (): string {
					return `${this.key}: ${this.y.toLocaleString()} Impressions`;
				}
			},
			legend: {
				align: 'right',
				verticalAlign: 'middle',
				layout: 'vertical',
				padding: 3,
				itemMarginTop: 5,
				itemMarginBottom: 5,
				labelFormatter: function (): string {
					return `${this.name}: ${this['percentage'].toFixed(1)}%`;
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					borderWidth: 0,
					showInLegend: true,
					dataLabels: {
						enabled: false
					},
					point: {
						events: {
							click: null
						}
					},
					innerSize: this.isR101 ? '75%' : '0%'
				},
				series: {
					states: {
						hover: {
							enabled: false
						},
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: [
				{
					events: {
						click: function (e) {
							e.preventDefault();
						}
					},
					type: 'pie',
					data: this.childVenueTypeData
				}
			]
		});
	}

	downloadDataInCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
}
